import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
// Syncfusion Material 3 theme, then our palette bridge — order matters, the bridge overrides it.
// material3.css carries both the light and dark palettes; ThemeContext switches between them by
// toggling `.e-dark-mode` on <body>.
import '@syncfusion/ej2/material3.css';
import './styles/syncfusion.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerLicense } from '@syncfusion/ej2-base';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

// Syncfusion Community licence, supplied per-environment via REACT_APP_SYNCFUSION_LICENSE
// (.env.local — gitignored, keys are version-specific). Registering removes the trial banner;
// left unregistered the grid still renders, with the banner.
//
// The registry this writes to is module-level state inside ej2-base, so the whole @syncfusion tree
// must resolve to ONE copy of that package — otherwise the grid reads a different, unregistered
// validator and the trial banner appears despite a valid key. package.json pins
// `@syncfusion/ej2-base` and `@syncfusion/ej2-grids` under `overrides` to keep it that way; don't
// drop those pins without re-checking `npm ls @syncfusion/ej2-base` returns a single entry.
if (process.env.REACT_APP_SYNCFUSION_LICENSE) {
  registerLicense(process.env.REACT_APP_SYNCFUSION_LICENSE);
} else {
  // Distinguishes "the build never got a key" from "the key was registered but rejected" —
  // both look identical from the trial banner alone.
  console.warn('REACT_APP_SYNCFUSION_LICENSE was not set at build time; Syncfusion runs in trial mode.');
}

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>
);

serviceWorkerRegistration.unregister();
reportWebVitals();
